import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from '../../../core/lib';
import { FORM } from '../utils/classes';
import './_styles.scss';

export interface IFormProps {
  id?: string;
  children: React.ReactElement | React.ReactElement[];
}

export interface IFormState {
  activeField: string;
  focusedField: string;
  values: { [key: string]: string };
}

export interface IFormChildContext {
  $form: {
    appendValue(value: string): void;
    sliceValue(start: number, end: number): void;
    empty(emptyAllField?: boolean, emptyCallback?: ()=>{}): void;
    updateActiveField(name: string): void;
    updateFocusedField(name: string): void;
    values: { [key: string]: string };
    activeField: string;
    setFieldMaxLength(name: string, maxLength: number): void;
  };
}

export class Form extends React.PureComponent<IFormProps, IFormState> {
  public static childContextTypes = {
    $form: PropTypes.object
  };

  private fieldsWithMaxLength: Record<string,number> = {};

  constructor(props: IFormProps) {
    super(props);
    this.state = {
      activeField: '',
      focusedField: '',
      values: {}
    };
  }

  public getChildContext(): IFormChildContext {
    const { values, activeField } = this.state;
    return {
      $form: {
        values,
        empty: this.empty,
        sliceValue: this.sliceValue,
        appendValue: this.appendValue,
        updateActiveField: this.updateActiveField,
        updateFocusedField: this.updateFocusedField,
        activeField,
        setFieldMaxLength: this.setFieldMaxLength,
      }
    };
  }

  private getCurrentValue(): string {
    const { activeField, values } = this.state;
    return values[activeField] ?? '';
  }

  @autobind
  private updateActiveField(name: string): void {
    this.setState({ activeField: name });
  }

  @autobind
  private updateFocusedField(name: string): void {
    this.setState({ focusedField: name });
  }
  @autobind
  private empty(allField: boolean = false, emptyCallback = () => {}): void {
    const { activeField, values } = this.state;
    if(allField){
      this.setState({
        values: {
          [activeField]: ''
        }
      }, emptyCallback);
    }
    else{
      this.setState({
        values: {
          ...values,
          [activeField]: ''
        }
      }, emptyCallback);
    }
  }

  @autobind
  private sliceValue(start: number, end: number): void {
    const { activeField, values } = this.state;
    const currentValue = this.getCurrentValue();
    this.setState({
      values: {
        ...values,
        [activeField]: currentValue.slice(start, end)
      }
    });
  }

  @autobind
  private appendValue(value: string): void {
    const { activeField, values } = this.state;
    const maxLength = this.fieldsWithMaxLength[activeField];
    const currentValue = this.getCurrentValue();
    const completeValue = `${currentValue}${value}`;
    if(maxLength && !isNaN(maxLength) && completeValue.length > maxLength){
      return;
    }
    this.setState({
      values: {
        ...values,
        [activeField]: completeValue
      }
    });
  }

  @autobind
  private setFieldMaxLength(name: string, maxLength: number): void {
    this.fieldsWithMaxLength[name] = maxLength;
  }

  public render(): JSX.Element {
    const { id, children } = this.props;
    return (
      <form id={id} className={FORM}>
        {children}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/packages/components/lib/Form/index.tsx